import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { numberFormat } from '../../../helpers/numberFormat';
import Modal from 'react-bootstrap/Modal';
import { DetailPembayaranIndividu } from '../..';
import { IconFiles } from '@tabler/icons-react';

const FinishPaymentIndividu = () => {

    const np = useSelector(state => state.nominalPayment)

    const size = useWindowSize();

    function useWindowSize() {
        // Initialize state with undefined width/height so server and client renders match
        // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
        const [windowSize, setWindowSize] = useState({
            width: undefined,
            height: undefined,
        });
        useEffect(() => {
            // Handler to call on window resize
            function handleResize() {
                // Set window width/height to state
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            }
            // Add event listener
            window.addEventListener("resize", handleResize);
            // Call handler right away so state gets updated with initial window size
            handleResize();
            // Remove event listener on cleanup
            return () => window.removeEventListener("resize", handleResize);
        }, []); // Empty array ensures that effect is only run on mount
        return windowSize;
    }

    const [showDetailPebayaran, setShowDetailPebayaran] = useState(false);

    return (
        <>
            <div className='col-lg-12' style={{ marginBottom: '3%' }}>
                {
                    size.width < 500 ?
                        <h5>Selesaikan Pembayaran</h5>
                        :
                        <h3 style={{ fontSize: '20px', fontWeight: '600' }}>Selesaikan Pembayaran</h3>
                }
                <hr style={{ marginBottom: '3%', marginTop: '3%' }}></hr>
                <div className='row mb-3'>
                    <div className='col-lg-12' style={{ backgroundColor: '#FFF3CD' }}>
                        <div className='col-lg-10' style={{ color: '#856404', marginBottom: '3%' }}>
                            {
                                size.width < 500 ?
                                    <>
                                        <p style={{ fontSize: '14px', fontWeight: '600', color: '#FE9D2C', marginTop: '3%', marginBottom: '3%' }}>Cara Pembayaran Via Transfer Bank</p>
                                        <ul>
                                            <li className='mb-3' style={{ fontSize: '14px', fontWeight: '400', color: '#191919' }}>
                                                1. Transfer ke nomor rekening bank yang tertera dibawah ini.
                                            </li>
                                            <li className='mb-3' style={{ fontSize: '14px', fontWeight: '400', color: '#191919' }}>
                                                2. Simpan notifikasi / struk transaksi sebagai bukti pembayaran.
                                            </li>
                                            <li className='mb-3' style={{ fontSize: '14px', fontWeight: '400', color: '#191919' }}>
                                                3. Upload bukti pembayaran di dashboard Riwayat Transaksi.
                                            </li>
                                        </ul>
                                    </>
                                    :
                                    <>
                                        <p style={{ fontSize: '16px', fontWeight: '600', color: '#FE9D2C', marginTop: '1%', marginBottom: '1%' }}>Cara Pembayaran Via Transfer Bank</p>
                                        <ul>
                                            <li style={{ fontSize: '16px', fontWeight: '400', color: '#191919' }}>
                                                1. Transfer ke nomor rekening bank yang tertera dibawah ini.
                                            </li>
                                            <li style={{ fontSize: '16px', fontWeight: '400', color: '#191919' }}>
                                                2. Simpan notifikasi / struk transaksi sebagai bukti pembayaran.
                                            </li>
                                            <li style={{ fontSize: '16px', fontWeight: '400', color: '#191919' }}>
                                                3. Upload bukti pembayaran di dashboard Riwayat Transaksi.
                                            </li>
                                        </ul>
                                    </>
                            }

                        </div>
                    </div>
                </div>
                <div className='row mb-3'>
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title" style={{ fontSize: '16px', fontWeight: '700' }}>Rekening Bank</h5>
                            <hr></hr>
                            <div className='col-lg-12 mt-3'>
                                <p style={{ fontSize: '15px', fontWeight: '400' }}>Nama Bank</p>
                                <p style={{ fontSize: '16px', fontWeight: '600' }}>BCA Serpong Branch</p>
                            </div>
                            <div className='col-lg-12 mt-3'>
                                <div className='row d-flex'>
                                    <div className='col-lg-6'>
                                        <p style={{ fontSize: '15px', fontWeight: '400' }}>Nomor Rekening Bank</p>
                                        <p style={{ fontSize: '16px', fontWeight: '600' }}>497 6700 988</p>
                                    </div>
                                    <div className='col-lg-6 text-right'>
                                        <button class="btn btn-sm btn-ghost-success" style={{ fontSize: size.width < 500 ? '14px' : '16px', fontWeight: '400' }} onClick={() => { navigator.clipboard.writeText(4976700988) }}>
                                            Salin <IconFiles width="20px" height="20px" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-12 mt-3'>
                                <p style={{ fontSize: '15px', fontWeight: '400' }}>Nama Rekening Bank</p>
                                <p style={{ fontSize: '16px', fontWeight: '600' }}>A/N PT. Prasetiya Mulya ELI</p>
                            </div>
                            <div className='col-lg-12 mt-3'>
                                <div className='row d-flex'>
                                    <div className='col-lg-6'>
                                        <p style={{ fontSize: '15px', fontWeight: '400' }}>Total Pembayaran</p>
                                        <p style={{ fontSize: '16px', fontWeight: '600' }}>Rp. {numberFormat(np.nominalPayment.grandtotal)}</p>
                                    </div>
                                    <div className='col-lg-6 text-right'>
                                        <button onClick={() => setShowDetailPebayaran(true)} class="btn btn-sm btn-ghost-success" style={{ fontSize: size.width < 500 ? '14px' : '16px', fontWeight: '400' }}>
                                            Lihat Detail
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <Modal
                show={showDetailPebayaran}
                size='xl'
                onHide={() => setShowDetailPebayaran(false)}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header
                    closeButton
                >
                    <Modal.Title>
                        <h3 className='m-3'>Detail Pembayaran</h3>
                    </Modal.Title>
                </Modal.Header >
                <Modal.Body>
                    <DetailPembayaranIndividu
                        close={() => setShowDetailPebayaran(false)}
                    />
                </Modal.Body>
            </Modal>
        </>
    )
}

export default FinishPaymentIndividu
